import { useEffect, useState } from "react";

//Components
import Loading from "../../../components/Loading/Loading";
import MainCard from "../../../components/MainCard/MainCard";
import TabelaListagem from "../../../components/TabelaListagem/TabelaListagem";
import NovaAutoInfracao from "./NovaAutoInfracao";
import FichaAutoInfracao from "./FichaAutoInfracao";

//Constants
import { actionsTable } from "../../../constants/MaterialTable";

//Context
import { useAuth } from "../../../context/auth";

//Helpers
import { showMessage } from "../../../helpers/message";

//API
import tipoAutoInfracao_api from "../../../api/tipoAutoInfracao_api";

export default function AutoDeInfracao({ permissao }) { 
    const [autosInfracoes, setAutosInfracoes] = useState([]);

    //Controle do loading na tela
    const {loading, setLoading} = useAuth();

    //Estado de controle da tela de nova auto de infração
    const [novoAutoInfracao, setNovoAutoInfracao] = useState(false);

    //Estado de controle para a ficha da auto de infração selecionada
    const [fichaAutoInfracao, setFichaAutoInfracao] = useState(null);

    //Função do clique do botão de editar auto de infração
    const editar = (item) => setFichaAutoInfracao(item.id);

    //Função do clique do botão de adicionar
    const nova = () => setNovoAutoInfracao(true);


    //Cabeçalhos da tabela de listagem de prefeituras
    const headers = [
        { value: "Fato Constitutivo", objectValue: "fatoConstitutivo", align: "left" },
        { value: "Preceitos Legais", objectValue: "preceitosLegais", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
        {  value: "Valor multa", objectValue: "valorMulta", align: "left" },
    ]
 
    //Variavel que guarda as ações da tabela 
    const actions = [actionsTable.visualizar(editar)]; 

    async function loadAutosDeInfracoes() {
        try {
            setLoading(true);
            const { data } = await tipoAutoInfracao_api.GetList();
            setAutosInfracoes(data || []);
        }catch(ex) {
            showMessage("Error", ex.message, "error", null);
        }finally {
            setLoading(false);
        }
    }

     //Função do botão de voltar
    const btnVoltar = () => { 
        setNovoAutoInfracao(false);
        setFichaAutoInfracao(null);
        loadAutosDeInfracoes();
    }

    useEffect(() => { 
        loadAutosDeInfracoes();
    }, [])

    //Controle da exibição da tela de nova auto de infração 
    if (novoAutoInfracao) {
        return <NovaAutoInfracao 
                    btnVoltar={btnVoltar} 
                />
    }

    //Controle da exibição da ficha da auto de infração selecionada
    if (fichaAutoInfracao) {
        return <FichaAutoInfracao   
                id={fichaAutoInfracao} 
                btnVoltar={btnVoltar} 
                permissao={permissao} 
            />
    }

    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={nova}>
                <div className="mt-4">
                    <TabelaListagem 
                        actions={actions} 
                        title={"Lista de auto de infrações"} 
                        options={
                            { 
                                print: false, 
                                search: true, 
                                pagination: true 
                            }
                        }
                        headers={headers} 
                        items={autosInfracoes.map((value) => {
                            value.valorMulta = value.valorMulta.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            });
                            return value;
                        })} 
                    />
                </div>
            </MainCard>
        </>
    )
}
